var exports = {
  "J": "xf0b3b88a--6d2817--lease-period",
};

module.exports = exports;
